/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
	  constructor() {
			super();
			this.pageHeight = window.innerHeight;
	  }

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
		    if (y > this.pageHeight) {
		      this.classList.add('back-to-top--active');
		    } else {
					this.classList.remove('back-to-top--active');
				}
			});
	  }

		onClick(event) {
			if (event.target.closest('.jdgm-rev__read-full') || event.target.querySelector('.jdgm-rev__read-full')) {
				return;
			}

			window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth"
		});
	  }
	}
	customElements.define('back-to-top', BackToTop);
}
